import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Send } from "lucide-react";
import { WhatsAppIcon } from "@/components/icons/WhatsAppIcon";
import { useLang } from "@/lib/i18n";

const CHANNEL_TG = "https://t.me/AliSalemps";

export default function FollowUs() {
    const [settings, setSettings] = useState({});
    const { t } = useLang();
    useEffect(() => { api.get("/public/settings").then((r) => setSettings(r.data || {})).catch(() => {}); }, []);
    const wa = (settings.social_whatsapp || "").trim();
    const isWaChannel = /whatsapp\.com\/channel\//.test(wa); // only show a WA card if it's a channel link
    return (
        <section className="mt-6" data-testid="follow-us">
            <h4 className="text-brand-black dark:text-white font-bold mb-3 font-display">{t("followUs")}</h4>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <a href={CHANNEL_TG} target="_blank" rel="noreferrer noopener"
                   className="glow-target group flex items-center gap-3 rounded-lg border border-gray-200 p-3 min-h-[68px] transition"
                   data-testid="follow-telegram">
                    <span className="h-10 w-10 rounded-sm bg-[#26A5E4] text-white flex items-center justify-center"><Send className="w-5 h-5" /></span>
                    <span className="flex-1 min-w-0">
                        <span className="block font-bold text-sm text-brand-black dark:text-white">{t("tgChannel")}</span>
                        <span className="block text-xs text-gray-500">{t("tgChannelSub")}</span>
                    </span>
                </a>
                {isWaChannel && (
                    <a href={wa} target="_blank" rel="noreferrer noopener"
                       className="glow-target group flex items-center gap-3 rounded-lg border border-gray-200 p-3 min-h-[68px] transition"
                       data-testid="follow-whatsapp">
                        <span className="h-10 w-10 rounded-sm bg-[#25D366] text-white flex items-center justify-center"><WhatsAppIcon className="w-5 h-5" /></span>
                        <span className="flex-1 min-w-0">
                            <span className="block font-bold text-sm text-brand-black dark:text-white">{t("waChannel")}</span>
                            <span className="block text-xs text-gray-500">{t("joinNow")}</span>
                        </span>
                    </a>
                )}
            </div>
        </section>
    );
}
